import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import AccountsList from 'accounts/components/list';
import { createRoute } from 'lib/util';

const { Form } = Common;

const AccountsListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <AccountsList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.accounts.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('accounts.accounts_title')}
          icon={'archive'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.accounts.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'accounts/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <AccountsList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <AccountsList.Table
              company={company} ////////
              subcompany={subcompany} ///////////
              permissions={permissions} ///////
              handleToggle={handleToggle} //////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </AccountsList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(AccountsListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/AccountsListView.js